import { render, staticRenderFns } from "./homeBseg.vue?vue&type=template&id=64f58aa4&scoped=true"
import script from "./homeBseg.vue?vue&type=script&lang=js"
export * from "./homeBseg.vue?vue&type=script&lang=js"
import style0 from "./homeBseg.vue?vue&type=style&index=0&id=64f58aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f58aa4",
  null
  
)

export default component.exports